/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */
import { __assign } from "tslib";
import { DirectVolume } from '../../mol-geo/geometry/direct-volume/direct-volume';
import { Lines } from '../../mol-geo/geometry/lines/lines';
import { Mesh } from '../../mol-geo/geometry/mesh/mesh';
import { Points } from '../../mol-geo/geometry/points/points';
import { Spheres } from '../../mol-geo/geometry/spheres/spheres';
import { Cylinders } from '../../mol-geo/geometry/cylinders/cylinders';
import { Text } from '../../mol-geo/geometry/text/text';
import { TextureMesh } from '../../mol-geo/geometry/texture-mesh/texture-mesh';
import { ParamDefinition as PD } from '../../mol-util/param-definition';
import { UnitKindOptions } from './visual/util/common';
export function getUnitKindsParam(defaultValue) {
    return PD.MultiSelect(defaultValue, UnitKindOptions, { description: 'For which kinds of units/chains to show the representation visuals.' });
}
export var StructureParams = {
    unitKinds: getUnitKindsParam(['atomic', 'spheres']),
    includeParent: PD.Boolean(false, { isHidden: true }),
};
export var StructureMeshParams = __assign({}, Mesh.Params);
export var StructureSpheresParams = __assign({}, Spheres.Params);
export var StructureCylindersParams = __assign({}, Cylinders.Params);
export var StructurePointsParams = __assign({}, Points.Params);
export var StructureLinesParams = __assign({}, Lines.Params);
export var StructureTextParams = __assign({}, Text.Params);
export var StructureDirectVolumeParams = __assign({}, DirectVolume.Params);
export var StructureTextureMeshParams = __assign({}, TextureMesh.Params);
//# sourceMappingURL=params.js.map